export default __webpack_public_path__ + "static/media/moren.58861870.png";